import { ArrowLeft, LogOut, ShieldAlert } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";
import { isAdminUiRole } from "@/lib/adminRoles";
import { getRoleHomePath } from "@/lib/navigation";
import { Button } from "@/components/ui/button";

const AccessDenied = ({ fullScreen = false }) => {
  const { logout, role } = useAuth();
  const navigate = useNavigate();
  const canReturnToDashboard = isAdminUiRole(role);

  const handleReturn = () => {
    navigate(canReturnToDashboard ? getRoleHomePath(role) : "/");
  };

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div
      className={`${fullScreen ? "min-h-screen bg-lenvia-bg" : "min-h-[60vh]"} flex items-center justify-center p-4 sm:p-6`}
    >
      <div className="w-full max-w-xl glass rounded-3xl border border-white/10 p-8 text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-500/10 text-red-300">
          <ShieldAlert className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-heading font-bold text-white">
          Accès refusé
        </h1>
        <p className="mt-3 text-sm text-slate-400">
          Votre rôle ne permet pas d&apos;accéder à cette page.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button type="button" onClick={handleReturn} className="btn-primary">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {canReturnToDashboard ? "Retour au Dashboard" : "Retour au site"}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={handleLogout}
            className="border-white/10 text-slate-300 hover:border-red-500/30 hover:bg-red-500/10 hover:text-red-300"
          >
            <LogOut className="mr-2 h-4 w-4" />
            Déconnexion
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
